import { Injectable, NgZone } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BrowserPaintService {
    private inRAF = false;

    constructor(
        private readonly ngZone: NgZone
    ) {
    }

    public runAfterPaint(callback: () => any, triggerChangeDetection: boolean = true): number {
        return triggerChangeDetection ? this.afterPaint(callback) : this.ngZone.runOutsideAngular(() => this.afterPaint(callback));
    }

    public runBeforeLayout(callback: () => any, triggerChangeDetection: boolean = true): number {
        return triggerChangeDetection ? this.beforeLayout(callback) : this.ngZone.runOutsideAngular(() => this.beforeLayout(callback));
    }

    public cancel(handle: number) {
        if (handle) {
            cancelAnimationFrame(handle);
        }
    }

    private afterPaint(callback: () => any): number {
        return this.beforeLayout(() => {
            setTimeout(callback, 0);
        });
    }

    private beforeLayout(callback: () => any): number {
        if (this.inRAF) {
            callback();
        } else {
            return requestAnimationFrame(() => {
                this.inRAF = true;
                callback();
                Promise.resolve().then(() => {
                    // In a Microtask, which will run after all the work of the Task has completed,
                    // turn off the "this.inRAF" flag, as we are about to exit the rAF context.
                    this.inRAF = false;
                });
            });
        }
    }
}
